import { Partner } from '@/configs/partner';

const HIPAA_SUBDOMAINS = new Set<Partner>([Partner.essence]);

export const isHipaa = (partner: Partner | undefined) =>
  partner ? HIPAA_SUBDOMAINS.has(partner) : false;
